import React from "react";
import { Truck, Mail, Phone, MapPin } from "lucide-react";

import { Link } from "react-router-dom";

import Logo from "../Assets/NSIRLOGO.png";
import "./Css/Footer.css";
const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center mb-4">
              <img className="logoImg" src={Logo} alt="Logo"></img>{" "}
              <span className="text-xl font-bold">NSIR</span>
            </div>
            <p className="text-gray-400 mb-4">
              One of the fastest growing companies in road transportation,
              providing comprehensive network coverage across India.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-gray-400 hover:text-white transition-colors"
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Services
                </Link>
              </li>
              <li>
                <Link
                  to="/fleet"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Fleet
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Info</h3>
            <div className="space-y-4">
              <div className="flex items-start">
                <Phone className="h-5 w-5 text-[#F80D01] mr-2 mt-1" />
                <div>
                  <p className="text-gray-400">+91 9893053069</p>
                  <p className="text-gray-400">+91 9827053069</p>
                </div>
              </div>
              <div className="flex items-start">
                <Mail className="h-5 w-5 text-[#F80D01] mr-2 mt-1" />
                <p className="text-gray-400">operations@nsirl.com</p>
              </div>
              <div className="flex items-start">
                <MapPin className="h-5 w-5 text-[#F80D01] mr-2 mt-1" />
                <p className="text-gray-400">
                  Khasra No. 269/1/2, Village-Rapadia,
                  <br />
                  Near Deepak Warehouse,
                  <br />
                  11 mile Bye pass Road, Bhopal (M.P.)
                </p>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Business Hours</h3>
            <ul className="space-y-2 text-gray-400">
              <li>Monday - Saturday</li>
              <li>9:00 AM - 6:00 PM</li>
              <li className="text-[#F80D01]">24/7 Emergency Support</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 text-center">
          <p className="text-gray-400">
            © {new Date().getFullYear()} New Southern India Roadlines. All
            rights reserved.
          </p>

          <a
            href="https://www.triosoft.ai/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-400 text-sm mt-2 TriLink"
          >
            Design and development by Triosoft Technology Pvt Ltd.
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
